import React, { useContext } from "react";
import Drawer from "@material-ui/core/Drawer";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from "react-i18next";
import Can from "../../can/Can";
import ExchangerContainer from "./ExchangerContainer";

import { AppContext } from "../../../App";
import { exchanger as exchangerRule  } from "../../../rbac-consts";

import { StyledToolbarButton } from "../navigation/toolbar/styledToolbar";
import { StyledExchangerWrapper } from "./styledExchanger";

const ExchangerBar = () => {
  const { t } = useTranslation("exchangerPage");

  const { user, exchanger } = useContext(AppContext);

  const {showExchanger, setShowExchanger} = exchanger;

  const toggleDrawer = () => {
    setShowExchanger(!showExchanger);
  };

  return (
    <>
      <StyledToolbarButton onClick={toggleDrawer} title={t("exchanger.title")}>
        <span className="icon-light-reload" />
      </StyledToolbarButton>
      <Drawer
        anchor="right"
        open={showExchanger}
        onClose={toggleDrawer}
      >
        <StyledExchangerWrapper>
          <div className="exchanger-head">
            <h3 className="title">
              {t("exchanger.title")}
            </h3>
            <span onClick={toggleDrawer} className="icon-light-cancel" />
          </div>
          <Can
            role={user.roles}
            perform={exchangerRule.USER}
            yes={() => (
              <ExchangerContainer />
            )}
            no={() => (
              <Alert className="exchanger-alert" severity="error">
                {t("exchanger.accessDenied")}
              </Alert>
            )}
          />
        </StyledExchangerWrapper>
      </Drawer>
    </>
  );
};

export default ExchangerBar;